import * as React from 'react'

/**
 * Section heading shared across the generic-entity surfaces. Mirrors the
 * `SectionHeader` used by the bespoke Plant detail pages (Equipment,
 * Compute host) so schema-driven pages read as part of the same family.
 */
export function SectionHeader({
  label,
  subtitle
}: {
  label: string
  subtitle?: string
}): React.ReactElement {
  return (
    <div className="mb-2 flex items-baseline gap-3">
      <h3 className="m-0 text-xs font-semibold uppercase tracking-[0.08em] text-ink-3">{label}</h3>
      {subtitle && <span className="text-xs text-ink-3">{subtitle}</span>}
    </div>
  )
}
